// eslint-disable-next-line boundaries/element-types
import { ProfileItem } from '@/widgets/sidebar/ui/ProfileItem';

import { Profile } from '@/shared/ui/Profile';

type Props = {
  active?: boolean;
  isAuthenticated?: boolean;
  variant?: 'filled' | 'outlined';
};

export const RecordingProfile = ({ active = false, isAuthenticated = true, variant = 'filled' }: Props) => {
  if (isAuthenticated) {
    return <ProfileItem active={active} variant={variant} />;
  }

  return <Profile cursor="default" email="you@yourcompany.com" planName="Free Plan" variant={variant} />;
};
